module.exports = __webpack_public_path__ + "static/media/Jarvis.f2267a31.svg";